import {
    GETALLOWCOUNTRYLIST_SUCCESS,
    GETALLOWCOUNTRYLIST_FAILED,
    RESET_GETALLOWCOUNTRYLIST,
    LOADING_GETALLOWCOUNTRYLIST,
    NETWORK_ERROR_GETALLOWCOUNTRYLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetAllowCountryList = () => {
    return { type: RESET_GETALLOWCOUNTRYLIST };
};

const getAllowCountryList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETALLOWCOUNTRYLIST });
    await partnerServices
        .post("getAllowCountryList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getAllowCountryListsuccess(res.data));
                    break;
                default:
                    dispatch(getAllowCountryListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETALLOWCOUNTRYLIST, payload: err });
        });
};
function getAllowCountryListsuccess(data) {
    return {
        type: GETALLOWCOUNTRYLIST_SUCCESS,
        payload: data,
    };
}
function getAllowCountryListFailed(data) {
    return {
        type: GETALLOWCOUNTRYLIST_FAILED,
        payload: data,
    };
}

export { resetGetAllowCountryList, getAllowCountryList };